// this file is generated from the root of the admin repo
// see https://github.com/tocktix/admin/wiki/Svg-Icons-Components in order to add a new file;
import * as React from "react";
import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";

export const SvgIconGrab = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    { width: "1em", height: "1em", viewBox: "0 0 24 24", ...props },
    <path d="M15 8.125v-2.5L12 3 9 5.625v2.5l2-1.75V11H6.375l1.75-2h-2.5L3 12l2.625 3h2.5l-1.75-2H11v4.625l-2-1.75v2.5L12 21l3-2.625v-2.5l-2 1.75V13h4.625l-1.75 2h2.5L21 12l-2.625-3h-2.5l1.75 2H13V6.375z" />
  );
export default SvgIconGrab;
